import * as React from 'react';
import type { SVGProps } from 'react';

const SvgLock = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="M18 8.5h-1v-2a5 5 0 0 0-10 0v2H6a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2v-10a2 2 0 0 0-2-2m-6 9a2 2 0 0 1-2-2c0-1.1.9-2 2-2a2 2 0 0 1 2 2 2 2 0 0 1-2 2m-3-9v-2a3 3 0 1 1 6 0v2z" />
  </svg>
);
export default SvgLock;
